import { FormControlLabel, GridColumn, Radio } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridColumn
			standardBorder
			textAlign="left"
			width={250}
		>
			<FormControlLabel
				control={<Radio />}
				label="Label1"
				labelPlacement="end"
				wrap={false}
			/>
			<FormControlLabel
				control={<Radio />}
				label="Label2"
				labelPlacement="end"
				wrap={false}
			/>
		</GridColumn>
	);
};
